<template>
  <div v-if="content" class="own-msg-wrap">
    <p class="own-msg">
      {{content}}
    </p>
  </div>
</template>

<script>
export default {
  props: {
    msgInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    content() {
      const { content = '' } = this.msgInfo;
      return content.replace(/(\\n|\\r|\\r\\n)/g, '\n');
    },
  },
};
</script>

<style lang="less">
.own-msg-wrap {
    display: flex;
    justify-content: end;
    .own-msg {
        padding: 14px;
        border-radius: 12px 12px 0 12px;
        background-image: linear-gradient(45deg, rgba(59, 220, 126, 1), rgba(13, 207, 169, 1));
        max-width: 240px;
        // word-break: break-all;
        font-style: 14px;
        line-height: 17px;
        font-family: Roboto;
        color: rgba(30, 30, 30, 1);
    }
}

</style>
